<div
  class="wrapper"
  [class.sidebar-visible]="sidebarVisible$ | async"
  [class.with-bottom-menu]="!bottomMenuHidden && !keyboardShown && mobileLayout$ | async"
>
  <hosty-app-sidebar class="sidebar" [items]="sidebarItems$ | async"></hosty-app-sidebar>
  @if (mobileLayout$ | async) {
    <div class="backdrop" (click)="toggleSidebar()"></div>
  }
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
@if (mobileLayout$ | async) {
  <hosty-app-mobile-bottom-menu
    class="menu"
    [hidden]="bottomMenuHidden || keyboardShown"
    [items]="bottomMenuItems$ | async"
    [menuMaxItemsCount]="bottomMenuMaxItemsCount"
  ></hosty-app-mobile-bottom-menu>
}
@if (mobileLayout$ | async) {
  <hosty-app-mobile-header class="header"></hosty-app-mobile-header>
}

@if (forceRefresh) {
  <div class="refresh">
    <img class="refresh-img" alt="" src="/assets/images/refresh.png" />
    <div class="refresh-title">We’ve Updated Hosty</div>
    <div class="refresh-text">Please reload this page to continue</div>
  </div>
}
